import React from 'react';
import {Icons, NavLink, Link, Settings} from 'components';
import {bounce, config, capitalize, useNamedSelector, modal} from 'helpers';
import {reset} from 'store/calendar';
import {forbid} from 'store/session';
import {set} from 'store/settings';
import css from './primary.module.scss';

export function Primary() {
  const { premium } = useNamedSelector('session.subscription');
  const { primaryNavigationCollapsed } = useNamedSelector('settings.ui');
  const { fullscreen } = useNamedSelector('calendar.settings');

  function collapse(event) {
    const isCollapsed = fullscreen || primaryNavigationCollapsed;
    event.preventDefault();
    const icon = event.target.closest('a').querySelector('svg');
    bounce(icon);
    set({ key: 'primaryNavigationCollapsed', value: !isCollapsed });
    if (isCollapsed) {
      set({ module: 'today', key: 'fullscreen', value: false });
    }
  }

  return (
    <div className={css.container}>
      <div className={css.menu}>

        <NavLink to="/today/" onClick={reset}>
          <Icons.Today /> Today
        </NavLink>

        <NavLink to="/goals/">
          <Icons.Goal /> My Goals
        </NavLink>

        <NavLink to="/activities/">
          <Icons.Clipboard /> Activities
        </NavLink>

        <NavLink to="/routines/">
          <Icons.Recurring /> Routines
        </NavLink>

        { config.sw &&
          <NavLink to="/habits/">
            <Icons.Habit /> Habits
          </NavLink>
        }

        <NavLink to="/diary/">
          <Icons.Diary /> Journal
        </NavLink>

        <NavLink to="/notes/">
          <Icons.Notepad /> Notes
        </NavLink>

        { config.sw &&
          <NavLink to="/lists/" onClick={premium ? undefined : forbid}>
            <Icons.List /> Lists
          </NavLink>
        }

        <NavLink to={`/${config.clarityModule}/`} className="orange">
          <Icons.Compass /> { capitalize(config.clarityModule) }
        </NavLink>

        <NavLink to={`/${config.identityModule}/`} className="orange" onClick={premium ? undefined : forbid}>
          <Icons.Identity /> { capitalize(config.identityModule) }
        </NavLink>

        <div className={css.separator} />

        <NavLink to="/settings/">
          <Icons.GearO /> Settings
        </NavLink>

        <Link to="." onClick={modal(Settings.Support)}>
          <Icons.Support /> Support
        </Link>

        <a target="_blank" href="https://successwizard.thrivecart.com/personal-coaching-session-1/?coupon=CO70">
          <Icons.Coach /> Coaching
        </a>

        <div className={css.separator} />

        <Link to="." onClick={collapse} className={css.chevron}>
          <Icons.ChevronO /> Collapse
        </Link>
      </div>
    </div>
  );
}
